import { Select } from "antd";
import styled from "styled-components";

export const StyledSelect = styled(Select)`
    .ant-select-item-option {
        height: 48px;
        line-height: 48px;
        font-size: 18px;
    }
`;
